import React, { Component } from 'react';
import { connect } from 'react-redux';
import CampaignsActions from '../../redux/CampaignsRedux';
import PageWithTable from '../../components/PageWithTable';
import { withTranslation } from 'react-i18next';
import DateCell from '../../components/DateCell';
import DictionariesActions from '../../redux/DictionariesRedux';
import Lozenge from '@atlaskit/lozenge';
import { convertUtcToLocal } from '../../helpers/dateHelper';
import Tooltip from '@atlaskit/tooltip';

const statusAppearanceMap = {
  "Выполнена": "success",
  "Создана": "default",
  "Активна": "moved",
  "Отменена": "removed"
};

const columns = t => ([
  {
    key: 'id',
    dataKey: 'id',
    title: t('ID'),
    sortable: true,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'name',
    dataKey: 'name',
    title: t('Name'),
    sortable: true,
    width: 150,
    flexGrow: 2,
    cellRenderer: ({ cellData }) => (
      <Tooltip content={cellData}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: 150,
        }}>
          {cellData}
        </div>
      </Tooltip>
    ),
  },
  {
    key: 'statusName',
    dataKey: 'statusName',
    title: t('Status'),
    sortable: true,
    width: 65,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      <Lozenge
      isBold={false}
      appearance={statusAppearanceMap[cellData] ?? "moved"}
    >
      <p>{cellData}</p>
    </Lozenge>
    ),
  },
  {
    key: 'firmwareName',
    dataKey: 'firmwareName',
    title: t('Firmware'),
    sortable: true,
    width: 175,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      <Tooltip content={cellData}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: 175
        }}>
          {cellData}
        </div>
      </Tooltip>
    ),
  }, 
  {
    key: 'toFactory',
    dataKey: 'toFactory',
    title: t('ToFactory'),
    sortable: true,
    width: 40,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      <Lozenge
        isBold={false}
        appearance={cellData ? "moved" : "inprogress"}
      >
        <p>{cellData ? t("Yes") : t("No")}</p>
      </Lozenge>
    ),
  },  
  {
    key: 'createdUserName',
    dataKey: 'createdUserName',
    title: t('Created User Name'),
    sortable: true,
    width: 130,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      <Tooltip content={cellData}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: 130,
        }}>
          {cellData}
        </div>
      </Tooltip>
    ),
  },   
  {
    key: 'updatedUserName',
    dataKey: 'updatedUserName',
    title: t('Updated User Name'),
    sortable: true,
    width: 80,
    flexGrow: 1,
    cellRenderer: ({ cellData }) => (
      <Tooltip content={cellData}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: 90,
        }}>
          {cellData}
        </div>
      </Tooltip>
    ),
  }, 
  {
    key: 'startDateTime',
    dataKey: 'startDateTime',
    title: t('Start Date'),
    sortable: true,
    width: 55,
    flexGrow: 2,
    cellRenderer: ({ cellData }) => (
      cellData &&
      <Tooltip content={<DateCell date={convertUtcToLocal(cellData)} />}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
            <DateCell date={convertUtcToLocal(cellData)} />
        </div>
      </Tooltip>
    ),
  },
  {
    key: 'endDateTime',
    dataKey: 'endDateTime',
    title: t('End Date'),
    sortable: true,
    width: 55,
    flexGrow: 2,
    cellRenderer: ({ cellData }) => (
      cellData &&
      <Tooltip content={<DateCell date={convertUtcToLocal(cellData)} />}>
        <div style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
            <DateCell date={convertUtcToLocal(cellData)} />
        </div>
      </Tooltip>
    ),
  },
  {
    key: 'totalDevices',
    dataKey: 'totalDevices',
    title: t('Total Devices'),
    sortable: true,
    width: 5,
    flexGrow: 1,
  },
  {
    key: 'inProgressDevices',
    dataKey: 'inProgressDevices',
    title: t('In Progress Devices'),
    sortable: true,
    width: 5,
    flexGrow: 1,
  },
  {
    key: 'successfulDevices',
    dataKey: 'successfulDevices',
    title: t('Successful Devices'),
    sortable: true,
    width: 5,
    flexGrow: 1,
  },
  {
    key: 'failedDevices',
    dataKey: 'failedDevices',
    title: t('Failed Devices'),
    sortable: true,
    width: 5,
    flexGrow: 1,
  }
]);

class CampaignsPage extends Component {
  componentDidMount() {
  }

  render() {
    const {
      campaignsData,
      fetching,
      totalPages,
      fetchCampaigns,
      permissions,
      getDictionaries,
      dictionaries,
      t,
    } = this.props;

    return (
      <PageWithTable
        actionButton={{
          title: t('Create campaign'),
          href: '/campaigns/new',
        }}
        filters={[
          {
            keyName: 'campaignStatuses',
            placeholder: t('Campaign Statuses'),
            data: dictionaries.campaignStatuses.data,
            fetching: dictionaries.campaignStatuses.fetching,
            getData: getDictionaries('campaignStatuses'),
          },
          {
            keyName: 'firmwares',
            placeholder: t('Firmwares'),
            data: dictionaries.firmwares.data,
            fetching: dictionaries.firmwares.fetching,
            getData: getDictionaries('firmwares'),
          }
        ]}
        dataColumns={columns(t)}
        data={campaignsData}
        dataFetching={fetching}
        dataTotalPages={totalPages}
        getData={fetchCampaigns}
        {...this.props}

        permissions={permissions}
      />
    );
  }
}

const mapStateToProps = state => (
  {
    permissions: state.userProfile.permissions.campaign,
    campaignsData: state.campaigns.data,
    totalPages: state.campaigns.totalPages,
    fetching: state.campaigns.fetching,
    dictionaries: state.dictionaries,
  });

const mapDispatchToProps = dispatch => ({
  fetchCampaigns: params => dispatch(CampaignsActions.campaignsRequest(params)),
  getDictionaries: name => () => dispatch(DictionariesActions.dictionariesRequest(name)),

});

export default withTranslation('fota')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(CampaignsPage));
